import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles.css';
import React, { useState } from 'react';
import { Offcanvas, Button, Row, Col, Card, Tabs, Tab } from 'react-bootstrap';
import Carousel from 'react-bootstrap/Carousel';
import DatePickerTab from '../components/datepicker';
import { FaRegAddressCard } from "react-icons/fa";
import { LuBuilding2 } from "react-icons/lu";
import { FaPhoneAlt } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa6";
import { PiStudentFill } from "react-icons/pi";
import { FaRegClipboard } from "react-icons/fa6";
import { RiAuctionLine } from "react-icons/ri";
import { BiNews } from "react-icons/bi";
import { PiNewspaperBold } from "react-icons/pi";
import { RiGalleryLine } from "react-icons/ri";
import { RiContactsBook3Line } from "react-icons/ri";
import { FaRegCalendarAlt } from "react-icons/fa";
import { GrScorecard } from "react-icons/gr";
import { RiInformation2Line } from "react-icons/ri";
import { TbAlertSquare } from "react-icons/tb";
import { FaAnglesRight } from "react-icons/fa6";
function NavbarTop() {
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [activeTab, setActiveTab] = useState('#whats-new');
  const [show, setShow] = useState(false);
  const [key, setKey] = useState('about');
  const [isPaused,] = useState(false);
  const [showStudentOffcanvas, setShowStudentOffcanvas] = useState(false);
  const [showCollegeOffcanvas, setShowCollegeOffcanvas] = useState(false);

  const handleShowStudent = () => setShowStudentOffcanvas(true);
  const handleCloseStudent = () => setShowStudentOffcanvas(false);

  const handleShowCollege = () => setShowCollegeOffcanvas(true);
  const handleCloseCollege = () => setShowCollegeOffcanvas(false);

  return (
    <>
    
      <main className='main-content' role='main'>
        {/* navbar part */}
        <Navbar expand="sm" className='shadow' fixed='top'>
          <Container fluid className='mx-5 p-0'>
            <Navbar.Brand href="#home" className='d-flex align-items-center'><img src='images/inter.png' className='logo' alt=''></img><b>APBIE</b></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto">
                <Nav.Link href="https://www.digilocker.gov.in/" target='_blank'><img src='images/digilocker_logo.png' className='ar' alt='' /></Nav.Link>
                <Nav.Link href="#home"><img src='images/ar.png' className='ar' alt='' /></Nav.Link>
                <Nav.Link href="#link" className='login'><button className='btn btn-sm login-btn '>Login</button></Nav.Link>
                <Nav.Link href="#link" className='login'><Button onClick={handleShow} style={{ position: 'absolute', zIndex: 1000, }} variant='light' className='full-menu'>
                  <img src='images/menu.png' alt='' className='menu-btn' />
                </Button>
                  <Offcanvas show={show} onHide={handleClose} placement="end" style={{ width: '100%', height: '100%' }} className="ffcanvas-bg1">
                    <img src='images/link-bg.png' className='canvas-bg' alt='' />
                    <img src='images/canvas-corner.png' className='canvas-corner' alt='' />
                    <Offcanvas.Header closeButton className="close-button-off close-button-off1"></Offcanvas.Header>
                    <Offcanvas.Body className='p-0 offcanvas-body'>
                      <Row>
                        <div className="tabs-container position-relative">
                          <Col xs={12} sm={12} lg={4} md={12} xl={4} xxl={4} className='left-canvas-tab p-0'>
                          <div className='left-side-tabs'>
                            <Row>
                              <Col xs={12} sm={12} lg={6} md={6} xl={6} xxl={6} className='col-left'>
                                <Tabs id="offcanvas-tabs" activeKey={key} onSelect={(k) => setKey(k)} className="flex-column tabs-nav left-nav-tabs">
                                  <Tab eventKey="about"   title={<Nav.Link href="#press-release"><div className='text-center w-100'><RiInformation2Line className=' about-svg mx-2'/><p>About Us</p></div></Nav.Link>}></Tab>
                                  <Tab eventKey="new" title={<Nav.Link href="#press-release"><div className='text-center w-100'><TbAlertSquare className='about-svg mx-2' /><p>What's New</p></div></Nav.Link>}/>
                                  <Tab eventKey="calendar"  title={<Nav.Link href="#press-release"><div className='text-center w-100'><FaRegCalendarAlt className='about-svg mx-2'/><p>Calendar</p></div></Nav.Link>}/>
                                  <Tab eventKey="contact"  title={<Nav.Link href="#press-release"><div className='text-center w-100'><RiContactsBook3Line className='about-svg mx-2'/><p>Contact Us</p></div></Nav.Link>} />
                                  <Tab eventKey="college" title={<Nav.Link href="https://biev2.apcfss.in/CollegesReport" target='_blank'><div className='text-center w-100'><LuBuilding2  className='about-svg mx-2'/><p>Info</p></div></Nav.Link>} />
                                  <Tab eventKey="memorandum"  title={<Nav.Link href="https://bie.ap.gov.in/ShortMemosLinks.do" target='_blank'><div className='text-center w-100'><GrScorecard className='about-svg mx-2'/><p>Memorandum Marks</p></div></Nav.Link>}/>
                                </Tabs>
                              </Col>
                              <Col xs={12} sm={12} lg={6} md={6} xl={6} xxl={6} className='col-left mt-2 mt-md-0'>
                                <Tabs
                                  id="offcanvas-tabs"
                                  activeKey={key}
                                  onSelect={(k) => setKey(k)}
                                  className="flex-column tabs-nav left-nav-tabs"
                                >
                                  <Tab eventKey="student" title={<Nav.Link href="#press-release"><div className='text-center w-100'><PiStudentFill className='about-svg mx-2'/><p>Students</p></div></Nav.Link>}/>
                                  <Tab eventKey="circulars" title={<Nav.Link href="#press-release"><div className='text-center w-100'><FaRegClipboard className='about-svg mx-2'/><p>Circulars</p></div></Nav.Link>} />
                                  <Tab eventKey="tenders" title={<Nav.Link href="#press-release"><div className='text-center w-100'><RiAuctionLine className='about-svg mx-2'/><p>Tenders</p></div></Nav.Link>}/>
                                  <Tab eventKey="gallery"  title={<Nav.Link href="https://bie.ap.gov.in/Gallery.do" target='_blank'><div className='text-center w-100'><RiGalleryLine className='about-svg mx-2'/><p>Gallery</p></div></Nav.Link>}/>
                                  <Tab eventKey="press-release" title={<Nav.Link href="https://biev2.apcfss.in/PressReleaseReport" target='_blank'><div className='text-center w-100'><PiNewspaperBold className='about-svg mx-2'/><p>Press Release</p></div></Nav.Link>}/>
                                  <Tab eventKey="press"  title={<Nav.Link href="https://biev2.apcfss.in/PressReport" target='_blank'><div className='text-center w-100'><BiNews className='about-svg mx-2' /><p>Press</p></div></Nav.Link>} />
                                </Tabs>
                              </Col>
                            </Row>
                            </div>
                          </Col>
                          <Col xs={12} sm={12} lg={8} md={12} xl={8} xxl={8} className=''>
                            <div className="tab-content ">
                              {key === 'about' && (
                                <div>
                                  <h4> About Us</h4>
                                  <p>In the year 1964, an important policy decision was taken to the effect that the structure
                                    of the Secondary School System should be of 10 years duration, instead of 11 years and that
                                    it should be followed by two-year Intermediate Collegiate Education, in place of the existing
                                    Higher Secondary and Multi-purpose system. Further, the two-year Intermediate course was to be
                                    followed in the existing Three-year Degree course. The new pattern of education has been put into
                                    effect from the academic year 1964-65, when an integrated syllabus was drawn up for 6th class with
                                    effect from that year. The first batch of students under the new system was in 10th class during 1968-69
                                    and attended Public Examinations in March/April 1969.</p>
                                  <p>In pursuance of the recommendations made by the various conferences of Vice-Chancellors, eminent
                                    educationists and others, considering the various problems in the introduction of two-year Intermediate
                                    course from 1969-70, the Government of Andhra Pradesh issued orders in G.O.Ms.No.1920, Education (V)
                                    Department, dated 25-10-1968, that the proposed two-year Intermediate course under the new pattern
                                    be called as the INTERMEDIATE COURSE OF TWO YEAR DURATION and introduced in certain colleges, Higher
                                    Secondary and Multipurpose High Schools which were designated as Junior Colleges vide G.O.Ms.No.1458 Edn.,
                                    Education (V) Department, dated 28-6-1969. Thus, the Intermediate Education System (IES)/Junior College System (JCS)
                                    in Andhra Pradesh state has been started functioning from 1969-70, under the control of the Director of Public
                                    Instruction (DPI).</p>
                                  <div className='about-btn d-flex align-items-center'>
                                    <button className='btn btn-sm board-btn '>Board Members</button>
                                    <button className='btn btn-sm chart-btn ms-3'>Organization Chart</button>
                                    <button className='btn btn-sm more-btn ms-3'>More</button>
                                  </div>
                                </div>
                              )}
                              {key === 'student' && (
                                 <div>
                                 <h4>Students</h4>
                                 <Row>
                                   <Col xs={12} sm={12} lg={6} md={6} xl={6} xxl={6}>
                                     <div className='migrate shadow'>
                                       <p><a href='https://biev2.apcfss.in/migrationcertificate'>Migration certificate</a></p>
                                     </div>
                                   </Col>
                                   <Col xs={12} sm={12} lg={6} md={6} xl={6} xxl={6}>
                                     <div className='migrate shadow'>
                                       <p><a href='https://biev2.apcfss.in/equivalencycertificate'>Equalency certificate</a></p>
                                     </div>
                                   </Col>
                                 </Row>
                                 <Row>
                                   <Col xs={12} sm={12} lg={6} md={6} xl={6} xxl={6}>
                                     <div className='migrate shadow'>
                                       <p><a href='https://biev2.apcfss.in/EligiblityCerti'>Eligibility certificate</a></p>
                                     </div>
                                   </Col>
                                   <Col xs={12} sm={12} lg={6} md={6} xl={6} xxl={6}>
                                     <div className='migrate shadow'>
                                       <p><a href='https://biev2.apcfss.in/DuplicateTripilateCerti'>Duplicate/Triplicate certificate</a></p>
                                     </div>
                                   </Col>
                                 </Row>
                                 <Row>
                                   <Col xs={12} sm={12} lg={6} md={6} xl={6} xxl={6}>
                                     <div className='migrate shadow'>
                                       <p><a href='https://biev2.apcfss.in/knowyourapplicationstatus'>Know Your Application Status</a></p>
                                     </div>
                                   </Col>
                                   <Col xs={12} sm={12} lg={6} md={6} xl={6} xxl={6}>
                                     <div className='migrate shadow'>
                                       <p><a href='https://biev2.apcfss.in/KnowYourAckNumber'>Know your Acknowledgement Number</a></p>
                                     </div>
                                   </Col>
                                 </Row>
                                 <Row>
                                   <Col xs={12} sm={12} lg={6} md={6} xl={6} xxl={6}>
                                     <div className='migrate shadow'>
                                       <p><a href='https://biev2.apcfss.in/ResourseMaterialWorkBook'>Resource Material/Work Book</a></p>
                                     </div>
                                   </Col>
                                   <Col xs={12} sm={12} lg={6} md={6} xl={6} xxl={6}>
                                     <div className='migrate shadow'>
                                       <p><a href='https://biev2.apcfss.in/ViewandDownloadApplication'>View and Download Application</a></p>
                                     </div>
                                   </Col>
                                 </Row>
                               </div>

                              )}
                              {key === 'new' && (
                                <div className='new-off'>
                                  <h4>What's new</h4>
                                  <marquee className={`marquee ${isPaused ? 'paused' : ''}`}
                                    style={{
                                      display: 'inline-block',
                                      animation: `marquee 10s linear infinite`,
                                      animationPlayState: isPaused ? 'paused' : 'running',
                                    }} direction="up" loop="">
                                    <p> <a href=''>I.P.A.S.E Vocational Bridge Course Results of 2nd Year</a></p>
                                    <p><a href=''>I.P.A.S.E Vocational Bridge Course Results of 1st Year</a> </p>
                                    <p><a href=''>I.P.E Vocational Bridge Course Results of 1st Year</a></p>
                                    <p><a href=''>I.P.E Vocational Bridge Course Results of 2nd Year</a></p>
                                    <p><a href=''>I.P.E General Bridge Course Results</a></p>
                                  </marquee>
                                  <p><a href=''>Admission into Degree Courses for Intermediate Vocational Pass out Students Eligibility
                                     Rules- Dispensation of No Objection/ Equivalency certificate
                                  Admission into Degree Courses for Intermediate Vocational Passout Students  Eligibility Rules 
                                  _ Submission of information regarding Dispensation of No Objection/ Equivalency certificate</a></p>
                                  <button className='btn btn-sm more-btn'>More</button>
                                </div>
                              )}
                              {key === 'circulars' && (
                                <div>
                                  <h4>Circulars</h4>
                                  <div className='circular-container'>
                                <div className='circular-off'>
                                  <a href='' className='circular-a'><span>Admission into Degree Courses for Intermediate Vocational Pass out Students – Eligibility Rules- Dispensation of No Objection/ 
                                  Equivalency certificate</span> 
                                  <p>Admission into Degree Courses for Intermediate Vocational Passout Students – Eligibility Rules _ 
                                  Submission of information regarding Dispensation of No Objection/ Equivalency certificate</p></a>
                                  <p className='date'>Jul 31, 2024</p>
                                </div>
                                <div className='circular-off pt-2'>
                                  <a href='' className='circular-a'><span>IPASE, 2024 - Online application / payment for Scanned copy - cum-Re-Verification of answer scripts</span> 
                                  <p>Intermediate Public Advanced Supplementary Examinations(IpASE) May, 2024 - Online application / payment for Scanned copy - cum-Re-Verification of answer scripts</p></a>
                                  <p className='date'>Jun 27, 2024</p>
                                </div>
                                <div className='circular-off pt-2'>
                                  <a href='' className='circular-a'><span>Conduct of Ethics and Human Values Examination</span> 
                                  <p>IPASE May 2024 – Conduct of Ethics and Human Values Examination- Posting of marks online- Despatch of answer books – Certain Instructions issued -Reg.</p></a>
                                  <p className='date'>May 31, 2024</p>
                                </div>
                                <div className='circular-off pt-2'>
                                  <a href='' className='circular-a'><span>Conduct of Environmental Education Examination</span> 
                                  <p>IPASE May 2024 - Conduct of Environmental Education Examination -Posting of Marks Online-Despatch of Answer Books– Certain Instructions issued-Reg.</p></a>
                                  <p className='date'>May 31, 2024</p>
                                </div>
                                </div>
                             <button className='btn btn-sm more-btn mt-3'>More</button>
                                </div>
                              )}
                              {key === 'tenders' && (
                                <div>
                                  <h4>Tenders</h4>
                                 <h5>No Tenders are Available</h5>
                                 <button className='btn btn-sm more-btn mt-3'>More</button>
                                </div>
                              )}
                              {key === 'calendar' && (
                                <div className='tel-calendar'>
                                 <DatePickerTab />
                                </div>
                              )}
                             {key === 'contact' && (
  <div className="contactus">
    <h4>Contact Us</h4>
    <div className="scroll-container">
      <div className="head-office">
        <h5>Head Office</h5>
        <div className="d-flex pt-4">
          <div className="head-svg">
            <FaRegAddressCard />
          </div>
          <div className="ms-3">
            <p style={{ width: '50%' }}>
              Office of the Secretary Board of Intermediate Education,<br />
              Andhra Pradesh, R.No.114/C3, 2nd, 3rd & 4th floors,
              Eswar Elite, Beside Sono-vision, Tadepalli,
              Guntur District, Pincode: 522501.
            </p>
          </div>
        </div>
        <div className="d-flex pt-4">
          <div className="head-svg">
            <FaPhoneAlt />
          </div>
          <div className="ms-3">
            <p className="ms-3">9392911819, 08645-277702</p>
            <p><b>Toll Free Number</b> - 1800 425 1531</p>
            <p>Follow us <FaTwitter /></p>
          </div>
        </div>
      </div>
      <div className="student-services">
        <h5>Student Services</h5>
       <Row className='mx-5'>
        <Col xs={12} sm={12} lg={5} md={5} xl={5} xxl={5}>
        <p>MIGRATION CERTIFICATE</p>
        <p>ELIGIBILITY CERTIFICATE</p>
        <p>NAME CORRECTION</p>
        <p>GENDER CORRECTION</p>
        <p>RV & RC</p>
        <p>PHOTO CORRECTIONS</p>
        </Col>
        <Col xs={12} sm={12} lg={5} md={5} xl={5} xxl={5}>
        <p>EQUIVALENCY CERTIFICATE</p>
        <p>DUPLICATE PASS CERTIFICATE</p>
        <p>PARENT NAME CORRECTION</p>
        <p>OLD MARK REPOSTING</p>
        <p>TRANSCRIPTS</p>
        <p>REMAINING ALL STUDENT ISSUES</p>
        </Col>
       </Row>
       <p><b>Mail Id:</b>studentservices.bieap@gmail.com
       </p>
      </div>
      <div className="student-services">
        <h5>College Services</h5>
       <Row className='mx-5'>
        <Col xs={12} sm={12} lg={5} md={5} xl={5} xxl={5}>
        <p>AFFILIATION</p>
        <p>ADDITIONAL COURSES</p>
        <p>COLLEGE NAME CHANGE</p>
        <p>ALL REMAINING COLLEGE ISSUES</p>
        </Col>
        <Col xs={12} sm={12} lg={5} md={5} xl={5} xxl={5}>
        <p>ADDITIONAL SECTIONS</p>
        <p>COLLEGE SHIFTING PROPOSAL</p>
        <p>SOCIETY NAME CHANGE</p>
        <p>OTHER</p>
        </Col>
       </Row>
       <p><b>Mail Id:</b>collegeservices.bieap@gmail.com
       </p>
      </div>
      <div className="student-services">
        <h5>ADMIN SERVICES</h5>
       <Row className='mx-5'>
        <Col xs={12} sm={12} lg={5} md={5} xl={5} xxl={5}>
        <p> HEAD OFFICE EMPLOYEE</p>
        <p>GRIEVANCES</p>
        <p>SERVICE MATTER ISSUES</p>
        </Col>
        <Col xs={12} sm={12} lg={5} md={5} xl={5} xxl={5}>
        <p>HEAD OFFICE & RIO OFFICE</p>
        <p>GRIEVANCES</p>
        <p>	OTHER</p>
        </Col>
       </Row>
       <p><b>Mail Id:</b>admnservices.bieap@gmail.com
       </p>
      </div>
    </div>
  </div>
)}
                            </div>
                          </Col>
                          </div>
                      </Row>
                    </Offcanvas.Body>
                  </Offcanvas>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        {/* ---------------navbar ends---------------------- */}
        {/* ------------------Bg-banner starts------------------------- */}
        <Container fluid className='background p-0'>
          <div class="bg-dashed">
            <div class="bg-dashed-line" style={{ width: '14.2%;' }}></div>
            <div class="bg-dashed-line"></div>
            <div class="bg-dashed-line"></div>
            <div class="bg-dashed-line"></div>
            <div class="bg-dashed-line"></div>
            <div class="bg-dashed-line"></div>
            <div class="bg-dashed-line"></div>
          </div>
          <div className='bg-banner'>
            <img src='images/dot-box3.png' alt='' className='wave' />
            <Row className='mx-0'>
              <Col xs={12} sm={12} lg={5} md={5} xl={5} xxl={5} className='bg-left'>
                <div class="left-boxes ms-auto">
                  <Row className='bg-col'>
                  <Col xs={6} sm={12} lg={6} md={6} xl={6} xxl={6} className='' style={{ cursor: 'pointer' }} onClick={handleShowStudent}>
        <div className="student-login shadow">
          <img src="images/student.png" alt="Student" className="img-fluid w-100" />
          <p>FOR STUDENTS</p>
        </div>
      </Col>

      <Offcanvas show={showStudentOffcanvas} onHide={handleCloseStudent} placement="top" style={{ height: '100vh'}} className="offcanvas-bg">
        <Offcanvas.Header closeButton className="close-button-off close-button-off2">
        </Offcanvas.Header>
        <Offcanvas.Body>
        <Container fluid>
         <img src='images/link-bg.png' className='student-bg' alt=''/>
         <Container className='student-service'>
                <h4 className='service-head'>Student <span>Services</span></h4>
                <Row  className='student-info'>
                   <Col xs={12} sm={12} lg={6} md={6} xl={4} xx={4} className='student-col'>
                   <a href='https://biev2.apcfss.in/migrationcertificate' target='_blank'>
                   <div className='migration-cer'>
                    <div>
                   <div className='flip-icon'>
                    <img src='images/graduate1.png' className='graduate' alt='' />
                   </div>
                    <h4>Migration<br></br>Certificate</h4>
                    </div>
                    </div>
                   </a>
                    </Col>
                    <Col xs={12} sm={12} lg={6} md={6} xl={4} xx={4} className='student-col mt-3 mt-xl-0 mt-lg-0 mt-md-0'>
                   <a href='https://biev2.apcfss.in/equivalencycertificate' target='_blank'>
                   <div className='migration-cer'>
                    <div>
                   <div className='flip-icon'>
                    <img src='images/graduate1.png' className='graduate' alt='' />
                   </div>
                    <h4>Equivalency<br></br>Certificate</h4>
                    </div>
                    </div>
                   </a>
                    </Col>
                    <Col xs={12} sm={12} lg={6} md={6} xl={4} xx={4} className='student-col mt-3 mt-xl-0  '>
                   <a href='https://biev2.apcfss.in/EligiblityCerti' target='_blank'>
                   <div className='migration-cer'>
                    <div>
                   <div className='flip-icon'>
                    <img src='images/graduate1.png' className='graduate' alt='' />
                   </div>
                    <h4>Eligibility<br></br>Certificate</h4>
                    </div>
                    </div>
                   </a>
                    </Col>
                    <Col xs={12} sm={12} lg={6} md={6} xl={4} xx={4} className='student-col mt-3 mt-xl-4 mt-lg-0 mt-md-0'>
                   <a href='https://biev2.apcfss.in/DuplicateTripilateCerti' target='_blank'>
                   <div className='migration-cer'>
                    <div>
                   <div className='flip-icon'>
                    <img src='images/graduate1.png' className='graduate' alt='' />
                   </div>
                    <h4>Duplicate/Triplicate<br></br>Pass Certificate</h4>
                    </div>
                    </div>
                   </a>
                    </Col>
                    <Col xs={12} sm={12} lg={6} md={6} xl={4} xx={4} className='student-col mt-3 mt-xl-4 mt-lg-0 mt-md-0'>
                    <a href='https://biev2.apcfss.in/namechange' target='_blank'>
                    <div className='migration-cer'>
                      <div>
                    <div className='flip-icon'>
                    <img src='images/graduate1.png' className='graduate' alt='' />
                   </div>
                    <h4>Name and Gender<br></br>Change</h4>
                    </div>
                    </div>
                    </a>
                    </Col>
                    <Col xs={12} sm={12} lg={6} md={6} xl={4} xx={4} className='student-col mt-3 mt-xl-4 '>
                   <a href='https://biev2.apcfss.in/knowyourapplicationstatus' target='_blank'>
                   <div className='migration-cer'>
                    <div>
                   <div className='flip-icon'>
                    <img src='images/graduate1.png' className='graduate' alt='' />
                   </div>
                    <h4>Know Your<br></br>Application Status</h4>
                    </div>
                    </div>
                   </a>
                    </Col>
                    <Col xs={12} sm={12} lg={6} md={6} xl={4} xx={4} className='student-col mt-3 mt-xl-4 mt-lg-0 mt-md-0'>
                   <a href='https://biev2.apcfss.in/KnowYourAckNumber' target='_blank'>
                   <div className='migration-cer'>
                    <div>
                   <div className='flip-icon'>
                    <img src='images/graduate1.png' className='graduate' alt='' />
                   </div>
                    <h4>Know Your<br></br>Acknowledgement Number</h4>
                    </div>
                    </div>
                   </a>
                    </Col>
                    <Col xs={12} sm={12} lg={6} md={6} xl={4} xx={4} className='student-col mt-3 mt-xl-4 mt-lg-0 mt-md-0'>
                    <a href='https://biev2.apcfss.in/ResourseMaterialWorkBook' target='_blank'>
                    <div className='migration-cer'>
                      <div>
                    <div className='flip-icon'>
                    <img src='images/graduate1.png' className='graduate' alt='' />
                   </div>
                    <h4>Resource<br></br>Material/Work Book</h4>
                    </div>
                    </div>
                    </a>
                    </Col>
                    <Col xs={12} sm={12} lg={6} md={6} xl={4} xx={4} className='student-col mt-3 mt-xl-4 '>
                    <a href='https://biev2.apcfss.in/ViewandDownloadApplication' target='_blank'>
                    <div className='migration-cer'>
                      <div>
                    <div className='flip-icon'>
                    <img src='images/graduate1.png' className='graduate' alt='' />
                   </div>
                    <h4>View & Download<br></br>Application Forms</h4>
                    </div>
                    </div>
                    </a>
                    </Col>
                </Row>
            </Container>
         </Container>
        </Offcanvas.Body>
      </Offcanvas>
                  <Col xs={6} sm={12} lg={6} md={6} xl={6} xxl={6} className='' style={{ cursor: 'pointer' }} onClick={handleShowCollege}>
        <div className="college-login shadow">
          <img src="images/college.png" alt="Student" className="img-fluid w-100" />
          <p>FOR COLLEGES</p>
        </div>
      </Col>

      <Offcanvas show={showCollegeOffcanvas} onHide={handleCloseCollege} placement="top" style={{ height: '100vh' }} className="offcanvas-bg">
        <Offcanvas.Header closeButton className="close-button-off close-button-off3">
        </Offcanvas.Header>
        <Offcanvas.Body>
        <Container fluid>
         <img src='images/link-bg.png' className='student-bg' alt=''/>
         <Container className='student-service'>
                <h4 className='service-head'>College <span>Services</span></h4>
                <Row  className='student-info'>
                   <Col xs={12} sm={12} lg={6} md={6} xl={4} xx={4} className='student-col'>
                   <a href='https://biev2.apcfss.in/AcademicPlanReport' target='_blank'>
                   <div className='migration-cer'>
                    <div>
                    <div className='flip-icon'>
                    <img src='images/graduate1.png' className='graduate' alt='' />
                   </div>
                    <h4>Academic Plan</h4>
                    </div>
                    </div>
                   </a>
                    </Col>
                    <Col xs={12} sm={12} lg={6} md={6} xl={4} xx={4} className='student-col mt-3 mt-xl-0 mt-lg-0 mt-md-0'>
                   <a href='https://bie.ap.gov.in/BluePrints.do' target='_blank'>
                   <div className='migration-cer'>
                    <div>
                    <div className='flip-icon'>
                    <img src='images/graduate1.png' className='graduate' alt='' />
                   </div>  
                    <h4>Blue Print</h4>
                    </div>
                    </div>
                   </a>
                    </Col>
                    <Col xs={12} sm={12} lg={6} md={6} xl={4} xx={4} className='student-col mt-3 mt-xl-0 mt-lg-0 mt-md-0'>
                   <a href='https://biev2.apcfss.in/CollegesReport' target='_blank'>
                   <div className='migration-cer'>
                    <div>
                    <div className='flip-icon'>
                    <img src='images/graduate1.png' className='graduate' alt='' />
                   </div>
                    <h4>Reports</h4>
                    </div>
                    </div>
                   </a>
                    </Col>
                </Row>
                <Row  className='student-info mt-4'>
                    <Col xs={12} sm={12} lg={6} md={6} xl={4} xx={4} className='student-col mt-3 mt-xl-0 mt-lg-0 mt-md-0'>
                   <a href='https://bie.ap.gov.in/LabManuals.do' target='_blank'>
                   <div className='migration-cer'>
                    <div>
                   <div className='flip-icon'>
                    <img src='images/graduate1.png' className='graduate' alt='' />
                   </div>
                    <h4>Lab Manuals</h4>
                    </div>
                    </div>
                   </a>
                    </Col>
                </Row>
            </Container>
         </Container>
        </Offcanvas.Body>
      </Offcanvas>
                  </Row>
                </div>
                {/* <img src='images/dot-box3.png' alt='' className='wave'/> */}
              </Col>
              <Col xs={12} sm={12} lg={7} md={7} xl={7} xxl={7} className='px-0 right-banner-part'>
                <div class="bie-right-img">
                  <img src='images/bg.png' alt='' className=' bg-img img-fluid' />

                  <svg width="144" height="541" className="apbie-img" viewBox="0 0 144 541" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="path-1-outside-1_28_485" maskUnits="userSpaceOnUse" x="-2.00002" y="-2.00001" width="161" height="546" fill="black">
                      <rect fill="white" x="-2.00002" y="-2.00001" width="161" height="546" />
                      <path d="M124.988 455.773L124.988 498.85L157 507.229L157 540.637L0.593748 491.76L0.593746 462.863L157 413.664L157 447.395L124.988 455.773ZM98.6699 491.975L98.6699 462.756L42.918 477.365L98.6699 491.975ZM102 367.365L157 367.365L157 398.947L0.593744 398.947L0.593741 345.666C0.593741 330.197 5.39192 317.88 14.9883 308.713C24.5846 299.475 37.0456 294.855 52.3711 294.855C67.6966 294.855 79.7995 299.403 88.6797 308.498C97.5599 317.593 102 330.197 102 346.311L102 367.365ZM75.6816 367.365L75.6816 345.666C75.6816 339.65 73.7122 334.995 69.7734 331.701C65.8346 328.407 60.1055 326.76 52.5859 326.76C44.7799 326.76 38.5853 328.443 34.0019 331.809C29.347 335.174 26.9837 339.686 26.9121 345.344L26.9121 367.365L75.6816 367.365ZM157 273.693L0.593738 273.693L0.593736 225.354C0.593735 209.025 4.24608 196.636 11.5508 188.186C18.7838 179.663 29.4186 175.402 43.4551 175.402C51.4043 175.402 58.2435 177.157 63.9726 180.666C69.7018 184.175 73.8913 188.973 76.541 195.061C78.5462 188.042 82.5924 182.635 88.6797 178.84C94.6953 175.044 102.143 173.146 111.023 173.146C126.206 173.146 137.664 177.336 145.398 185.715C153.133 194.022 157 206.089 157 221.916L157 273.693ZM89.0019 242.111L130.789 242.111L130.789 221.916C130.789 216.258 129.034 211.962 125.525 209.025C122.016 206.089 117.039 204.621 110.594 204.621C96.5573 204.621 89.36 209.706 89.0019 219.875L89.0019 242.111ZM66.0137 242.111L66.0137 225.676C66.0137 213.286 59.6042 207.092 46.7851 207.092C39.6953 207.092 34.6107 208.524 31.5312 211.389C28.4518 214.253 26.9121 218.908 26.9121 225.354L26.9121 242.111L66.0137 242.111ZM157 117.18L157 148.762L0.593733 148.762L0.593731 117.18L157 117.18ZM89.3242 9.86523L89.3242 59.0644L130.789 59.0644L130.789 0.841789L157 0.841788L157 90.6465L0.59373 90.6465L0.593726 1.05664L26.9121 1.05664L26.9121 59.0644L63.8652 59.0644L63.8652 9.86523L89.3242 9.86523Z" />
                    </mask>
                    <path d="M124.988 455.773L124.482 453.839L122.988 454.23L122.988 455.773L124.988 455.773ZM124.988 498.85L122.988 498.85L122.988 500.393L124.482 500.784L124.988 498.85ZM157 507.229L159 507.229L159 505.685L157.506 505.294L157 507.229ZM157 540.637L156.403 542.546L159 543.357L159 540.637L157 540.637ZM0.593748 491.76L-1.40625 491.76L-1.40625 493.23L-0.00280214 493.669L0.593748 491.76ZM0.593746 462.863L-0.00638557 460.955L-1.40625 461.396L-1.40625 462.863L0.593746 462.863ZM157 413.664L159 413.664L159 410.938L156.4 411.756L157 413.664ZM157 447.395L157.506 449.329L159 448.938L159 447.395L157 447.395ZM98.6699 491.975L98.1629 493.909L100.67 494.566L100.67 491.975L98.6699 491.975ZM98.6699 462.756L100.67 462.756L100.67 460.164L98.1629 460.821L98.6699 462.756ZM42.918 477.365L42.411 475.431L35.0279 477.365L42.411 479.3L42.918 477.365ZM122.988 455.773L122.988 498.85L126.988 498.85L126.988 455.773L122.988 455.773ZM124.482 500.784L156.494 509.163L157.506 505.294L125.495 496.915L124.482 500.784ZM155 507.229L155 540.637L159 540.637L159 507.229L155 507.229ZM157.597 538.728L1.1903 489.851L-0.00280214 493.669L156.403 542.546L157.597 538.728ZM2.59375 491.76L2.59375 462.863L-1.40625 462.863L-1.40625 491.76L2.59375 491.76ZM1.19388 464.771L157.6 415.572L156.4 411.756L-0.00638557 460.955L1.19388 464.771ZM155 413.664L155 447.395L159 447.395L159 413.664L155 413.664ZM156.494 445.46L124.482 453.839L125.495 457.708L157.506 449.329L156.494 445.46ZM100.67 491.975L100.67 462.756L96.6699 462.756L96.6699 491.975L100.67 491.975ZM98.1629 460.821L42.411 475.431L43.4249 479.3L99.1769 464.691L98.1629 460.821ZM42.411 479.3L98.1629 493.909L99.1769 490.04L43.4249 475.431L42.411 479.3ZM102 367.365L100 367.365L100 369.365L102 369.365L102 367.365ZM157 367.365L159 367.365L159 365.365L157 365.365L157 367.365ZM157 398.947L157 400.947L159 400.947L159 398.947L157 398.947ZM0.593744 398.947L-1.40626 398.947L-1.40626 400.947L0.593744 400.947L0.593744 398.947ZM14.9883 308.713L16.3697 310.159L16.3753 310.154L14.9883 308.713ZM88.6797 308.498L87.2487 309.895L88.6797 308.498ZM75.6816 367.365L75.6816 369.365L77.6816 369.365L77.6816 367.365L75.6816 367.365ZM34.0019 331.809L35.1738 333.429L35.1798 333.425L35.1858 333.421L34.0019 331.809ZM26.9121 345.344L24.9123 345.318L24.9121 345.331L24.9121 345.344L26.9121 345.344ZM26.9121 367.365L24.9121 367.365L24.9121 369.365L26.9121 369.365L26.9121 367.365ZM102 369.365L157 369.365L157 365.365L102 365.365L102 369.365ZM155 367.365L155 398.947L159 398.947L159 367.365L155 367.365ZM157 396.947L0.593744 396.947L0.593744 400.947L157 400.947L157 396.947ZM2.59374 398.947L2.59374 345.666L-1.40626 345.666L-1.40626 398.947L2.59374 398.947ZM2.59374 345.666C2.59374 330.645 7.23437 318.885 16.3697 310.159L13.6068 307.267C3.54947 316.874 -1.40626 329.749 -1.40626 345.666L2.59374 345.666ZM16.3753 310.154C25.5427 301.328 37.4789 296.855 52.3711 296.855L52.3711 292.855C36.6122 292.855 23.6266 297.621 13.6012 307.272L16.3753 310.154ZM52.3711 296.855C67.2767 296.855 78.8204 301.263 87.2487 309.895L90.1107 307.101C80.7785 297.543 68.1165 292.855 52.3711 292.855L52.3711 296.855ZM87.2487 309.895C95.6732 318.524 100 330.573 100 346.311L104 346.311C104 329.821 99.4466 316.663 90.1107 307.101L87.2487 309.895ZM100 346.311L100 367.365L104 367.365L104 346.311L100 346.311ZM77.6816 367.365L77.6816 345.666L73.6816 345.666L73.6816 367.365L77.6816 367.365ZM77.6816 345.666C77.6816 339.171 75.5297 333.908 71.0565 330.167L68.4903 333.235C71.8948 336.083 73.6816 340.13 73.6816 345.666L77.6816 345.666ZM71.0565 330.167C66.6233 326.459 60.3627 324.76 52.5859 324.76L52.5859 328.76C59.8482 328.76 65.0459 330.355 68.4903 333.235L71.0565 330.167ZM52.5859 324.76C44.5097 324.76 37.8519 326.5 32.8181 330.197L35.1858 333.421C39.3187 330.385 45.0502 328.76 52.5859 328.76L52.5859 324.76ZM32.8301 330.188C27.6715 333.918 24.992 339.017 24.9123 345.318L28.9119 345.369C28.9754 340.356 31.0225 336.431 35.1738 333.429L32.8301 330.188ZM24.9121 345.344L24.9121 367.365L28.9121 367.365L28.9121 345.344L24.9121 345.344ZM26.9121 369.365L75.6816 369.365L75.6816 365.365L26.9121 365.365L26.9121 369.365ZM157 273.693L157 275.693L159 275.693L159 273.693L157 273.693ZM0.593738 273.693L-1.40626 273.693L-1.40626 275.693L0.593738 275.693L0.593738 273.693ZM11.5508 188.186L13.0638 189.493L13.0697 189.487L13.0756 189.48L11.5508 188.186ZM76.541 195.061L74.7072 195.859L76.9324 200.971L78.4641 195.61L76.541 195.061ZM88.6797 178.84L89.7379 180.537L89.7469 180.531L88.6797 178.84ZM145.398 185.715L143.929 187.071L143.935 187.078L145.398 185.715ZM89.0019 242.111L87.0019 242.111L87.0019 244.111L89.0019 244.111L89.0019 242.111ZM130.789 242.111L130.789 244.111L132.789 244.111L132.789 242.111L130.789 242.111ZM89.0019 219.875L87.0032 219.805L87.0019 219.84L87.0019 219.875L89.0019 219.875ZM66.0137 242.111L66.0137 244.111L68.0137 244.111L68.0137 242.111L66.0137 242.111ZM26.9121 242.111L24.9121 242.111L24.9121 244.111L26.9121 244.111L26.9121 242.111ZM157 271.693L0.593738 271.693L0.593738 275.693L157 275.693L157 271.693ZM2.59374 273.693L2.59374 225.354L-1.40626 225.354L-1.40626 273.693L2.59374 273.693ZM2.59374 225.354C2.59374 209.289 6.19073 197.445 13.0638 189.493L10.0377 186.878C2.30143 195.827 -1.40626 208.762 -1.40626 225.354L2.59374 225.354ZM13.0756 189.48C19.8347 181.516 29.8431 177.402 43.4551 177.402L43.4551 173.402C28.9941 173.402 17.733 177.811 10.0259 186.891L13.0756 189.48ZM43.4551 177.402C51.1039 177.402 57.5668 179.088 62.928 182.372L65.0173 178.961C58.9202 175.226 51.7047 173.402 43.4551 173.402L43.4551 177.402ZM62.928 182.372C68.3118 185.669 72.2233 190.153 74.7072 195.859L78.3748 194.262C75.5592 187.794 71.0918 182.681 65.0173 178.961L62.928 182.372ZM78.4641 195.61C80.3357 189.059 84.0792 184.065 89.7379 180.537L87.6215 177.143C81.1057 181.206 76.7567 187.026 74.618 194.511L78.4641 195.61ZM89.7469 180.531C95.3722 176.982 102.427 175.146 111.023 175.146L111.023 171.146C101.859 171.146 94.0184 173.107 87.6124 177.148L89.7469 180.531ZM111.023 175.146C125.841 175.146 136.687 179.226 143.929 187.071L146.868 184.358C138.641 175.446 126.57 171.146 111.023 171.146L111.023 175.146ZM143.935 187.078C151.208 194.89 155 206.394 155 221.916L159 221.916C159 205.784 155.057 193.154 146.862 184.352L143.935 187.078ZM155 221.916L155 273.693L159 273.693L159 221.916L155 221.916ZM89.0019 244.111L130.789 244.111L130.789 240.111L89.0019 240.111L89.0019 244.111ZM132.789 242.111L132.789 221.916L128.789 221.916L128.789 242.111L132.789 242.111ZM132.789 221.916C132.789 215.819 130.878 210.896 126.809 207.492L124.242 210.559C127.191 213.027 128.789 216.698 128.789 221.916L132.789 221.916ZM126.809 207.492C122.817 204.152 117.319 202.621 110.594 202.621L110.594 206.621C116.759 206.621 121.215 208.027 124.242 210.559L126.809 207.492ZM110.594 202.621C103.388 202.621 97.5972 203.917 93.5144 206.801C89.3221 209.763 87.2003 214.205 87.0032 219.805L91.0007 219.945C91.1616 215.375 92.8175 212.191 95.8224 210.068C98.9369 207.868 103.763 206.621 110.594 206.621L110.594 202.621ZM87.0019 219.875L87.0019 242.111L91.0019 242.111L91.0019 219.875L87.0019 219.875ZM68.0137 242.111L68.0137 225.676L64.0137 225.676L64.0137 242.111L68.0137 242.111ZM68.0137 225.676C68.0137 219.155 66.3232 213.902 62.5964 210.3C58.8824 206.71 53.4862 205.092 46.7851 205.092L46.7851 209.092C52.9031 209.092 57.1212 210.571 59.8166 213.176C62.4994 215.769 64.0137 219.807 64.0137 225.676L68.0137 225.676ZM46.7851 205.092C39.5125 205.092 33.8014 206.545 30.169 209.924L32.8934 212.853C35.4199 210.503 39.8781 209.092 46.7851 209.092L46.7851 205.092ZM30.169 209.924C26.509 213.329 24.9121 218.646 24.9121 225.354L28.9121 225.354C28.9121 219.171 30.3946 215.178 32.8934 212.853L30.169 209.924ZM24.9121 225.354L24.9121 242.111L28.9121 242.111L28.9121 225.354L24.9121 225.354ZM26.9121 244.111L66.0137 244.111L66.0137 240.111L26.9121 240.111L26.9121 244.111ZM157 117.18L159 117.18L159 115.18L157 115.18L157 117.18ZM157 148.762L157 150.762L159 150.762L159 148.762L157 148.762ZM0.593733 148.762L-1.40627 148.762L-1.40627 150.762L0.593733 150.762L0.593733 148.762ZM0.593731 117.18L0.593731 115.18L-1.40627 115.18L-1.40627 117.18L0.593731 117.18ZM155 117.18L155 148.762L159 148.762L159 117.18L155 117.18ZM157 146.762L0.593733 146.762L0.593733 150.762L157 150.762L157 146.762ZM2.59373 148.762L2.59373 117.18L-1.40627 117.18L-1.40627 148.762L2.59373 148.762ZM0.593731 119.18L157 119.18L157 115.18L0.593731 115.18L0.593731 119.18ZM89.3242 9.86523L91.3242 9.86523L91.3242 7.86523L89.3242 7.86523L89.3242 9.86523ZM89.3242 59.0644L87.3242 59.0644L87.3242 61.0644L89.3242 61.0644L89.3242 59.0644ZM130.789 59.0644L130.789 61.0644L132.789 61.0644L132.789 59.0644L130.789 59.0644ZM130.789 0.841789L130.789 -1.15821L128.789 -1.15821L128.789 0.841789L130.789 0.841789ZM157 0.841788L159 0.841788L159 -1.15821L157 -1.15821L157 0.841788ZM157 90.6465L157 92.6465L159 92.6465L159 90.6465L157 90.6465ZM0.59373 90.6465L-1.40627 90.6465L-1.40627 92.6465L0.59373 92.6465L0.59373 90.6465ZM0.593726 1.05664L0.593726 -0.943361L-1.40627 -0.943361L-1.40627 1.05664L0.593726 1.05664ZM26.9121 1.05664L28.9121 1.05664L28.9121 -0.943363L26.9121 -0.943363L26.9121 1.05664ZM26.9121 59.0644L24.9121 59.0644L24.9121 61.0644L26.9121 61.0644L26.9121 59.0644ZM63.8652 59.0644L63.8652 61.0644L65.8652 61.0644L65.8652 59.0644L63.8652 59.0644ZM63.8652 9.86523L63.8652 7.86523L61.8652 7.86523L61.8652 9.86523L63.8652 9.86523ZM87.3242 9.86523L87.3242 59.0644L91.3242 59.0644L91.3242 9.86523L87.3242 9.86523ZM89.3242 61.0644L130.789 61.0644L130.789 57.0644L89.3242 57.0644L89.3242 61.0644ZM132.789 59.0644L132.789 0.841789L128.789 0.841789L128.789 59.0644L132.789 59.0644ZM130.789 2.84179L157 2.84179L157 -1.15821L130.789 -1.15821L130.789 2.84179ZM155 0.841788L155 90.6465L159 90.6465L159 0.841788L155 0.841788ZM157 88.6465L0.59373 88.6465L0.59373 92.6465L157 92.6465L157 88.6465ZM2.59373 90.6465L2.59373 1.05664L-1.40627 1.05664L-1.40627 90.6465L2.59373 90.6465ZM0.593726 3.05664L26.9121 3.05664L26.9121 -0.943363L0.593726 -0.943361L0.593726 3.05664ZM24.9121 1.05664L24.9121 59.0644L28.9121 59.0644L28.9121 1.05664L24.9121 1.05664ZM26.9121 61.0644L63.8652 61.0644L63.8652 57.0644L26.9121 57.0644L26.9121 61.0644ZM65.8652 59.0644L65.8652 9.86523L61.8652 9.86523L61.8652 59.0644L65.8652 59.0644ZM63.8652 11.8652L89.3242 11.8652L89.3242 7.86523L63.8652 7.86523L63.8652 11.8652Z" fill="#CACACA" mask="url(#path-1-outside-1_28_485)" />
                  </svg>
                  <div className='bg-ellipse'><img src='images/bg-ellipse.png' alt='' className='img-fluid' /></div>
                  <div className='bird'><img src='images/bird1.png' alt='' className='img-fluid' /></div>
                  <div className='bird1'><img src='images/bird2.png' alt='' className='img-fluid' /></div>
                  <div className='bg-main'><img src='images/bg-main.png' alt='' className='img-fluid' /></div>

                </div>
              </Col>
            </Row>
          </div>

        </Container>
        {/* ------------------------Bg-banner ends---------------------- */}
        {/* ---------------------Link-parts starts-------------- */}
        <Container fluid className='alerts-section'>
          <img src='images/link-bg.png' className='link-bg' alt='' />
          <img src='images/dot-box1.png' className='corner-img' alt='' />
          <Row className='alerts-row'>
            <Col sm={12} xs={12} lg={6} md={12} xl={6} xxl={6} className='alerts'>
              <div className='alerts-total'>
                <h4>Latest <span>Alerts</span></h4>
                <div className='alerts-col'>
                  {/* <marquee class="marq" direction="up" loop="">
            <p className='text-white'>I.P.A.S.E Vocational Bridge Course Results 
            of 2nd Year</p>
            <p className='text-white'>I.P.A.S.E Vocational Bridge Course Results of 1st Year</p>
            <p className='text-white'>I.P.A.S.E  Results 2024</p>
            <p className='text-white'>I.P.A.S.E Reservation(RV) Results </p>
            </marquee > */}
                  <p className='text-white'>I.P.A.S.E Vocational Bridge Course Results
                    of 2nd Year</p>
                  <p className='text-white'>I.P.A.S.E Vocational Bridge Course Results of 1st Year</p>
                  <p className='text-white'>I.P.A.S.E  Results 2024</p>
                  <p className='text-white'>I.P.A.S.E Reservation(RV) Results</p>
                </div>
              </div>
            </Col>
            <Col sm={12} xs={12} lg={6} md={12} xl={6} xxl={6} className='quick-links '>
              <h4 className='quick-head'>Quick <span> Links</span></h4>
              <div className='link-info'>
                <Row className='mx-0'>
                  <Col sm={12} xs={12} lg={5} md={5} xl={5} xxl={5} className='graduate-info shadow' onClick={handleShowStudent}>
                    <div className='graduate-img'>
                      <div className='flip-icon'>
                        <img src='images/graduate1.png' className='graduate' alt='' />
                      </div>
                      <h4>Students</h4>
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi libero erat, tincidunt vitae dictum ac, lacinia ut eros.</p>
                    </div>
                  </Col>
                  <Col sm={12} xs={12} lg={5} md={5} xl={5} xxl={5} className='graduate-info1 shadow ms-5' onClick={handleShowCollege}>
                    <div className='graduate-img'>
                      <div className='flip-icon'> <img src='images/school1.png' className='graduate' alt='' /></div>
                      <h4>Colleges</h4>
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi libero erat, tincidunt vitae dictum ac, lacinia ut eros.</p>
                    </div>
                  </Col>
                </Row>
                <Row className='mx-0'>
                 <Col sm={12} xs={12} lg={5} md={5} xl={5} xxl={5} className='graduate-info shadow mt-5'>
                  <a href='https://resultsbie.ap.gov.in/' target='_blank'>
                  <div className='graduate-img'>
                      <div className='flip-icon'> <img src='images/login1.png' className='graduate' alt='' /></div>
                      <h4>Results</h4>
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi libero erat, tincidunt vitae dictum ac, lacinia ut eros.</p>
                    </div>
                  </a>
                  </Col>
                 <Col sm={12} xs={12} lg={5} md={5} xl={5} xxl={5} className='graduate-info1 shadow ms-5 mt-5' >
                 <a href='https://biev2.apcfss.in/papers' target='_blank'> <div className='graduate-img'>
                      <div className='flip-icon'> <img src='images/report1.png' className='graduate' alt='' /></div>
                      <h4>Question Papers</h4>
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi libero erat, tincidunt vitae dictum ac, lacinia ut eros.</p>
                    </div></a>
                   
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
        {/* --------------Link-parts ends------------------- */}
        {/* -----------------About Part------------------- */}
        <Container fluid className='about-section p-0'>
          <div class="bg-dashed">
            <div class="bg-dashed-line"></div>
            <div class="bg-dashed-line"></div>
            <div class="bg-dashed-line"></div>
            <div class="bg-dashed-line"></div>
            <div class="bg-dashed-line"></div>
            <div class="bg-dashed-line"></div>
            <div class="bg-dashed-line"></div>
          </div>
          <Container className='p-5'>
            <div className='about-part'>
              <Row>
                <Col xs={12} sm={12} lg={6} md={12} xl={6} xxl={6} className=''>
                  <div className='about-head ps-5 pt-5'><h4 className='pb-4'>About <span> APBIE</span></h4>
                    <p className=''>In the year 1964, an important policy decision was taken to the effect that the
                      structure of the Secondary School System should be of 10 years duration, instead
                      of 11 years and that it should be followed by two-year Intermediate Collegiate Education,
                      in place of the existing Higher Secondary and Multi-purpose system. Further, the two-year
                      Intermediate course was to be followed in the existing Three-year Degree course.
                      The new pattern of education has been put into effect from the academic year 1964-65,
                      when an integrated about was drawn up for 6th class with effect from that year.
                      The first batch of students under the new system was in 10th class during 1968-69 and
                      attended Public Examinations in March/April 1969.</p>
                    <button class="know-more">
                      <span class="circle" aria-hidden="true">
                        <span class="icon arrow"></span>
                      </span>
                      <span class="button-text">Know More</span>
                    </button>
                  </div>
                </Col>
                <Col xs={12} sm={12} lg={6} md={12} xl={6} xxl={6} >
                  <div className='about-right py-5'>
                    <Nav variant="tabs" activeKey={activeTab} onSelect={(selectedKey) => setActiveTab(selectedKey)}>
                      <Nav.Item className='new-btn'>
                        <Nav.Link eventKey="#whats-new" >What's New</Nav.Link>
                      </Nav.Item>
                      <Nav.Item className='cir-btn'>
                        <Nav.Link eventKey="#circulars" >Circulars</Nav.Link>
                      </Nav.Item>
                    </Nav>

                    {activeTab === '#circulars' && (
                      <div id='circulars'>
                        <h4 className="mt-3 mb-3">
                          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="22" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                          </svg>
                          Circulars
                        </h4>
                        <Carousel>
                          <Carousel.Item>
                            {[1, 2, 3].map((_, index) => (
                              <Card className="mb-3" key={index}>
                                <Card.Body className="d-flex justify-content-between">
                                  <div>
                                    <p>Admission into Degree Courses for Intermediate Vocational Pass out Students Eligibility Rules - Submission of information regarding Dispensation of No Objection/ Equivalency certificate</p>
                                  </div>
                                  <div className="d-flex align-items-center">
                                    <span className="bg-secondary text-white  rotated-text">July 31, 2024</span>
                                  </div>
                                </Card.Body>
                              </Card>
                            ))}
                          </Carousel.Item>
                          <Carousel.Item>
                            {[1, 2, 3].map((_, index) => (
                              <Card className="mb-3" key={index}>
                                <Card.Body className="d-flex justify-content-between">
                                  <div>
                                    <p>Admission into Degree Courses for Intermediate Vocational Pass out Students Eligibility Rules - Submission of information regarding Dispensation of No Objection/ Equivalency certificate</p>
                                  </div>
                                  <div className="d-flex align-items-center">
                                    <span className="bg-secondary text-white  rotated-text">July 31, 2024</span>
                                  </div>
                                </Card.Body>
                              </Card>
                            ))}
                          </Carousel.Item>
                          <Carousel.Item>
                            {[1, 2, 3].map((_, index) => (
                              <Card className="mb-3" key={index}>
                                <Card.Body className="d-flex justify-content-between">
                                  <div>
                                    <p>Admission into Degree Courses for Intermediate Vocational Pass out Students Eligibility Rules - Submission of information regarding Dispensation of No Objection/ Equivalency certificate</p>
                                  </div>
                                  <div className="d-flex align-items-center">
                                    <span className="bg-secondary text-white  rotated-text">July 31, 2024</span>
                                  </div>
                                </Card.Body>
                              </Card>
                            ))}
                          </Carousel.Item>
                        </Carousel>
                      </div>
                    )}

                    {activeTab === '#whats-new' && (
                      <div id='whats-new'>
                        <h4 className="mt-3 mb-3">
                          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="22" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                          </svg>
                          What's New
                        </h4>
                        <Carousel>
                          <Carousel.Item>
                            {[1, 2, 3].map((_, index) => (
                              <Card className="mb-3" key={index}>
                                <Card.Body className="d-flex justify-content-between">
                                  <div>
                                    <p>Admission into Degree Courses for Intermediate Vocational Pass out Students Eligibility Rules - Submission of information regarding Dispensation of No Objection/ Equivalency certificate
                                    </p>
                                  </div>
                                  <div className="d-flex align-items-center">
                                    <span className="bg-secondary text-white  rotated-text">July 31, 2024</span>
                                  </div>
                                </Card.Body>
                              </Card>
                            ))}
                          </Carousel.Item>
                          <Carousel.Item>
                            {[1, 2, 3].map((_, index) => (
                              <Card className="mb-3" key={index}>
                                <Card.Body className="d-flex justify-content-between">
                                  <div>
                                    <p>Admission into Degree Courses for Intermediate Vocational Pass out Students Eligibility Rules - Submission of information regarding Dispensation of No Objection/ Equivalency certificate</p>
                                  </div>
                                  <div className="d-flex align-items-center">
                                    <span className="bg-secondary text-white  rotated-text">July 31, 2024</span>
                                  </div>
                                </Card.Body>
                              </Card>
                            ))}
                          </Carousel.Item>
                          <Carousel.Item>
                            {[1, 2, 3].map((_, index) => (
                              <Card className="mb-3" key={index}>
                                <Card.Body className="d-flex justify-content-between">
                                  <div>
                                    <p>Admission into Degree Courses for Intermediate Vocational Pass out Students Eligibility Rules - Submission of information regarding Dispensation of No Objection/ Equivalency certificate</p>
                                  </div>
                                  <div className="d-flex align-items-center">
                                    <span className="bg-secondary text-white  rotated-text">July 31, 2024</span>
                                  </div>
                                </Card.Body>
                              </Card>
                            ))}
                          </Carousel.Item>
                        </Carousel>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </Container>
        {/* --------------------About Part Ends---------------------- */}
        {/* ---------------------Syllabus part Starts------------------- */}
        <Container fluid className='syllabus-section'>
          <div className='syllabus-col p-5'>
            <img src='images/link-bg.png' className='link-bg' alt='' />

            <Container className='my-5'>
              <img src='images/dot-box1.png' className='corner-img' alt='' />
              <Row>
                <Col xs={12} sm={12} lg={6} md={12} xl={6} xxl={6} className='text-center py-5'>
                  <Carousel>
                    <Carousel.Item>
                      <div className='bie-img'>
                        <img src='images/bie-img.png' alt='' className='img-fluid' />
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className='bie-img1 text-center'>
                        <img src='images/bie-img1.png' alt='' className='img-fluid' />
                      </div>
                    </Carousel.Item>
                    <Carousel.Item>
                      <div className='bie-img'>
                        <img src='images/bie-img.png' alt='' className='img-fluid' />
                      </div>
                    </Carousel.Item>
                  </Carousel>
                </Col>
                <Col xs={12} sm={12} lg={6} md={12} xl={6} xxl={6} className='syllabus-right'>
                  <h4 className='syllabus-head'>Syllabus &<span> Resources</span></h4>
                  <Row className='mt-5'>
                    <Col xs={12} sm={12} lg={6} md={6} xl={6} xxl={6}>
                      <div className='question p-3 shadow'>
                        <img src='images/que.png' className='que-bg  img-fluid flip-icon' alt='' />
                        <p className=''>Syllabus and Question
                          Bank (Practical)</p>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} lg={6} md={6} xl={6} xxl={6} className='mt-3 mt-xl-0 mt-lg-0 mt-md-0'>
                      <div className='resource p-3 shadow'>
                        <img src='images/res.png' className='que-bg  img-fluid flip-icon' alt='' />
                        <p className=''>Resource</p>
                      </div>
                    </Col>
                  </Row>
                  <Row className='mt-4'>
                    <Col xs={12} sm={12} lg={6} md={6} xl={6} xxl={6}>
                      <div className='virtual p-3 shadow'>
                        <img src='images/vir.png' className='que-bg  img-fluid flip-icon' alt='' />
                        <p className=''>Virtual Class</p>
                      </div>
                    </Col>
                  </Row>
                  {/* <div className='syllabus-col'>
                <div className='question d-flex p-3'>
                    <img src='images/que.png' className='que-bg ms-auto img-fluid' alt=''/>
                  <p className='ps-5 pe-3'>Syllabus and Question 
                  Bank (Practical)</p>
                </div>
                <div className='resource d-flex p-3 mt-3'>
                  <p className='ps-5'>Resource</p>
              <img src='images/res.png' className='que-bg ms-auto img-fluid' alt=''/>
                </div>
                <div className='virtual d-flex p-3 mt-3'>
                  <p className='ps-5'>Virtual Class</p>
              <img src='images/vir.png' className='que-bg ms-auto img-fluid' alt=''/>
                </div>
              </div> */}
                </Col>
              </Row>
            </Container>
          </div>
        </Container>
      </main>
      {/* ---------------------Syllabus part Ends------------------- */}
      <footer className="fixed-footer">
        <div className="content">
          <Container fluid className='fluid-content'>
            <Row className='mx-5 pt-5'>
              <Col xs={12} sm={12} lg={4} md={12} xl={4} xxl={4}>
                <div className="contact-map pt-5 d-flex justify-content-center">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3825.8660757329035!2d80.61623221110143!3d16.482317628180446!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35f1ece3b141f1%3A0xe33e071b33de90df!2sBoard%20of%20Intermediate%20Education%2C%20Andhra%20Pradesh%20(APBIE)!5e0!3m2!1sen!2sin!4v1723026137330!5m2!1sen!2sin"
                    width="80%"
                    height="250"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade" title=''
                  />
                </div>
              </Col>
              <Col xs={12} sm={12} lg={4} md={12} xl={4} xxl={4}>
                <div className="contact-text pt-5">
                  <h4 className="mt-3">
                    Quick <span>Links</span>
                  </h4>
                  <Row>
                    <Col xs={12} sm={12} lg={6} md={6} xl={6} xxl={6}>
                    <div className=" pt-4 quick-info">
                    <div className="links-info ms-3">
                     <p><a href='https://www.ap.gov.in' target='_blank'><FaAnglesRight /> AP State Portal </a></p>
                    <p><a href='https://jnanabhumi.ap.gov.in/' target='_blank'><FaAnglesRight /> JnanaBhumi</a></p>
                     <p><a href='https://apsche.ap.gov.in/' target='_blank'><FaAnglesRight /> APSCHE</a></p>
                    <p><a href='https://affiliation.apcfss.in/' target='_blank'><FaAnglesRight /> Affiliation</a></p>
                    <p> <a href='https://skilluniverse.apssdc.in/' target='_blank'><FaAnglesRight /> AP Skill Development</a></p>
                    </div>
                  </div>
                    </Col>
                    <Col xs={12} sm={12} lg={6} md={6} xl={6} xxl={6}>
                    <div className=" pt-4 quick-info">
                    <div className="links-info ms-3">
                     <p><a href='http://www.apcce.gov.in/#gsc.tab=0' target='_blank'><FaAnglesRight /> APCCE </a></p>
                    <p><a href='https://dteap.nic.in/' target='_blank'><FaAnglesRight /> DTEAP</a></p>
                     <p><a href='https://bieaffiliation.apcfss.in/' target='_blank'><FaAnglesRight /> BIE Affiliation</a></p>
                     <p><a href='https://schooledu.ap.gov.in/' target='_blank'><FaAnglesRight /> School Education</a></p>
                    <p> <a href='https://apegazette.cgg.gov.in/' target='_blank'><FaAnglesRight /> AP e-Gazette</a></p>
                    </div>
                  </div>
                    </Col>
                  </Row>
                
                </div>
              </Col>
              <Col xs={12} sm={12} lg={4} md={12} xl={4} xxl={4}>
                <div className="contact-text pt-5">
                  <h4 className="mt-3">
                    Get in <span>Touch</span>
                  </h4>
                  <div className="d-flex pt-4  contact-info">
                    <div className="address-svg">
                      <img src="images/office.png" className="office-svg" alt="" />
                    </div>
                    <div className="address ms-3">
                      <p>
                        Office of the Secretary Board of Intermediate Education,<br />
                        Andhra Pradesh,
                        R.No.114/C3, 2nd, 3rd & 4th floors,
                        Eswar Elite, Beside Sono-vision,
                        Tadepalli, Guntur District, Pincode: 522501.
                      </p>
                    </div>
                  </div>
                  <div className="d-flex pt-2 align-items-center contact-info">
                    <div className="address-svg">
                      <img src="images/phone.png" className="office-svg" alt="" />
                    </div>
                    <div className="phone ms-3">
                      <p className="mt-0 mb-0">9392911819, 08645-277702.</p>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="disclaimer text-center pt-5">
              <h4>Legal Disclaimer</h4>
              <p className="text-white">
                The information contained in this Web Site has been prepared solely for the purpose of providing information
                about Board of Intermediate Education, Andhra Pradesh to interested parties, and is not in any way binding on
                Board of Intermediate Education, Andhra Pradesh.
              </p>
            </div>
          </Container>
          <div className="footer text-center footer-bottom">
            <p className="mb-0">
              Designed and Developed by{' '}
             <a href='https://apcfss.in/' target='_blank'> <img src="images/footer-logo.png" className="footer-logo" alt="" /></a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}
export default NavbarTop;